import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, type Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

export class FirebaseService {
  private messagingPromise: Messaging | null = null;

  async getMessaging(): Promise<Messaging | null> {
    if (typeof window === 'undefined') return null;

    if (!this.messagingPromise) {
      const supported = await isSupported();
      if (!supported) return null;

      const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

      this.messagingPromise = getMessaging(app);
    }

    return this.messagingPromise;
  }

  async getToken(serviceWorkerRegistration: ServiceWorkerRegistration): Promise<string | null> {
    if (typeof window === 'undefined') return null;

    if (!this.messagingPromise) return null;

    return getToken(this.messagingPromise, {
      vapidKey: process.env.NEXT_PUBLIC_FIREBASE_KEYPAIR,
      serviceWorkerRegistration,
    });
  }
}

export const firebaseService = new FirebaseService();
